import { useEffect, useRef, useState } from 'react';

import { Anchor } from '@klv/atoms/anchor';
import Button from '@klv/atoms/button';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/animationOutline.module.scss';

import type { IAnimationOutline } from './types';

const AnimationOutline = ({
  buttonText,
  children,
  className,
  forceHover,
  openInNewTab = false,
  outline = true,
  style,
  url,
}: IAnimationOutline & Omit<React.HTMLProps<HTMLAnchorElement>, 'href'>) => {

  const containerRef = useRef<HTMLDivElement>(null);

  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);

  const imagePerimeter = (containerWidth * 2) + (containerHeight * 2);

  useEffect(() => {
    if (containerRef.current) {
      const box = containerRef.current.getBoundingClientRect();
      setContainerWidth(box.width);
      setContainerHeight(box.height);
    }
  }, []);

  return (
    <Anchor
      aria-label={url ? buttonText : ''}
      className={generateClassName([styles.animationOutline, 'animationOutline'])}
      href={url}
      style={style}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <div
        className={generateClassName([
          className,
          styles.imageContainer,
          !!url && styles.isAnchor,
          forceHover && styles.forceHoverState,
        ])}
        ref={containerRef}
      >

        { children }

        {outline && (
          <svg
          style={{
            strokeDasharray: `${imagePerimeter}px`,
            strokeDashoffset: `${imagePerimeter}px`,
          }}
          viewBox={`0 0 ${containerWidth} ${containerHeight}`}
          >
            <rect x="2" y="2" rx="9" strokeWidth="4" />
          </svg>
        )}

        <div className={styles.hoverContainer}>
          <div className={styles.hoverSlideContainer}>
            {buttonText && (
              <Button
                className={styles.button}
                text={buttonText}
                setTabIndex={-1}
                buttonColor="light"
              />
            )}
          </div>
        </div>

      </div>
    </Anchor>
  );
};

export default AnimationOutline;
